(() => {
  const initialize = () => {
    document.querySelectorAll('[data-ff-2027-header]').forEach((header) => {
      if (header.dataset.ff2027Ready) return;
      const section = header.closest('.shopify-section-header');
      if (!section) return;
      header.dataset.ff2027Ready = 'true';
      section.classList.add('ff-2027-header-section');
      const announcement = document.querySelector('.section-announcement');
      const search = header.querySelector('[data-ff-2027-search]');
      const toggle = search?.querySelector('summary');
      const field = search?.querySelector('input[type="search"]');
      const widget = search?.querySelector('ff-header-search');
      let frame;
      const update = () => {
        frame = null;
        const bottom = announcement?.getBoundingClientRect().bottom || 0;
        section.style.setProperty('--ff-2027-header-top', `${Math.max(0, bottom)}px`);
        section.classList.toggle('ff-2027-header--scrolled', window.scrollY > (announcement?.offsetHeight || 0));
      };
      const scheduleUpdate = () => {
        if (frame == null) frame = window.requestAnimationFrame(update);
      };
      const closeSearch = (restoreFocus = false) => {
        if (!search?.open) return;
        widget?.close?.();
        search.open = false;
        toggle?.setAttribute('aria-expanded', 'false');
        if (restoreFocus) toggle?.focus({ preventScroll: true });
      };
      if (search && toggle) {
        toggle.setAttribute('aria-expanded', String(search.open));
        search.addEventListener('toggle', () => {
          toggle.setAttribute('aria-expanded', String(search.open));
          if (search.open) field?.focus({ preventScroll: true });
          else widget?.close?.();
        });
        search.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !search.open) return;
          event.preventDefault();
          event.stopPropagation();
          closeSearch(true);
        }, true);
        document.addEventListener('pointerdown', (event) => {
          if (!search.contains(event.target)) closeSearch();
        });
        search.addEventListener('focusout', () => {
          window.setTimeout(() => {
            if (!search.contains(document.activeElement)) closeSearch();
          }, 0);
        });
      }
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      const observer = new ResizeObserver(scheduleUpdate);
      observer.observe(header);
      if (announcement) observer.observe(announcement);
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(header)) return;
        observer.disconnect();
        window.removeEventListener('scroll', scheduleUpdate);
        window.removeEventListener('resize', scheduleUpdate);
        if (frame != null) window.cancelAnimationFrame(frame);
      });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
